const updateDynamicValues = (canvasState, command) => canvasState.update(
    'dynamicValues',
    dynamicValues => dynamicValues.merge(command.get('update'))
);

export default updateDynamicValues;
